import { gsap } from "gsap"

declare var $

export class ProgressBar {

  el: HTMLElement
  sectionCount: number

  constructor(el, sectionCount) {
    this.el = el
    this.sectionCount = sectionCount
    this.initProgress()
  }

  initProgress() {

    const frame = 1 / this.sectionCount
    for(let i = 0; i < this.sectionCount; i++) {
      $('<div class="progress-marker"></div>')
        .css({ left: (frame * (i+0.5) * 100) + '%' })
        .appendTo($('.progress', this.el))
    }

    const $progress = $('.progress-bar', this.el)
    gsap.set($progress, {width: 0})
    gsap.to($progress, {
        scrollTrigger: {
          id: 'progressbar',
          trigger: this.el,
          start: "top top",
          end: "bottom bottom",
          scrub: 0,
        },
        ease: 'none',
        width: '100%'
      })
  }

}